<template>
    <div class="step-two">
      <div class="step-two__form">
        <div class="step-two__dates argus-glass-surface">
        <b-form-group
                id="startDate-form"
                label="Дата начала смены"
                label-for="startDate"
                label-class="label-class"
                class="mb-0"
        >
            <input type="date" class="form-control datepicker" id="startDate" v-model="startDate" @change="startDateChange"/>
        </b-form-group>
            <b-form-group v-if="!availableCache.length" id="startTime-form" label="Время начала" label-for="startTime" label-class="label-class" class="mb-0">
                <input type="time" class="form-control timepicker" id="startTime" v-model="startTime"/>
            </b-form-group>
            <b-form-group v-if="!availableCache.length" id="endDate-form" label="Дата окончания смены" label-for="endDate" label-class="label-class" class="mb-0">
                <input type="date" class="form-control datepicker" id="endDate" v-model="endDate" :min="getMinDate" :max="getMaxDate"/>
            </b-form-group>
            <b-form-group v-if="!availableCache.length" id="endTime-form" label="Время окончания" label-for="endTime" label-class="label-class" class="mb-0">
                <input type="time" class="form-control timepicker" id="endTime" v-model="endTime"/>
            </b-form-group>
        </div>
        <b-card v-if="availableCache.length" class="w-100 mt-3 text-center">
            <span class="text-info">Вы ранее уже начинали заполнять отчёт за эту дату. Хотите продолжить?</span>
            <div v-for="cache in availableCache" :key="cache.id" class="my-2">
                <span class="small">
                    Последнее обновление по данному отчету было <b>{{ $moment(cache.updatedAt).format('DD.MM.yyyy HH:mm (dddd)')
                    }}</b>
                </span>
                <b-button size="sm" variant="success" class="my-2 d-block mx-auto" @click="onUploadClick">
                    Да, продолжить начатое
                </b-button>
                <b-button size="sm" variant="danger" class="my-2 d-block mx-auto" @click="onContinueClick">
                    Нет, сделаем отчёт заново
                </b-button>
            </div>
        </b-card>
        <div v-else>
            <p class="text-danger mt-2" role="alert" v-if="notValid()">Дата окончания смены не может быть раньше начала смены</p>
            <b-form-group
                v-if="isMoreThanThreeDays()"
                id="reasonForDelay-form"
                :label="textQualityEnabled ? null : 'Укажите причину просрочки подачи отчёта'"
                label-class="label-class text-danger"
                class="w-100 mt-4"
        >
            <ReportExplanationField v-if="textQualityEnabled" kind="delay" :reason-key.sync="delayReasonKey" :detail.sync="reasonForDelay" />
            <AppTextarea v-else
                    id="textarea"
                    v-model="reasonForDelay"
                    placeholder="Например: зазевался"
                    class="step-two__detail"
            ></AppTextarea>
        </b-form-group>
        </div>
        <ReportExplanationStatisticsPanel v-if="textQualityEnabled" kind="delay"
            :reason-key="!availableCache.length && isMoreThanThreeDays() ? delayReasonKey : ''" />
      </div>
    </div>
</template>

<script>
import ReportExplanationField from '../ReportExplanationField.vue';
import ReportExplanationStatisticsPanel from '../ReportExplanationStatisticsPanel.vue';
import explanations from '../../../../../shared/reportExplanations';
export default {
    name: "StepTwo",
    components: {ReportExplanationField, ReportExplanationStatisticsPanel},
    computed: {
        textQualityEnabled() { return this.$store.state.shiftReport.textQualityEnabled; },
        delayReasonKey: {
            get() { return this.$store.state.shiftReport.delayReasonKey; },
            set(value) { this.$store.commit('shiftReport_setDelayReasonKey', value); this.$store.dispatch('shiftReport_updateCache'); }
        },
        canContinue() {
            if (this.notValid()) return false;
            if (!this.isMoreThanThreeDays()) return true;
            return this.textQualityEnabled
                ? !explanations.validateExplanation('delay', this.delayReasonKey, this.reasonForDelay)
                : Boolean(this.reasonForDelay);
        },
        availableCache() {
            return this.$store.state.shiftReport.availableCache;
        },
        startDate: {
            get() {
                return this.$store.state.shiftReport.startDate;
            },
            set(v) {
                this.$store.commit(`shiftReport_setStartDate`, v);
            }
        },
        startTime: {
            get() {
                return this.$store.state.shiftReport.startTime;
            },
            set(v) {
                this.$store.commit(`shiftReport_setStartTime`, v);
                this.$store.dispatch(`shiftReport_updateCache`);
            }
        },
        endDate: {
            get() {
                return this.$store.state.shiftReport.endDate;
            },
            set(v) {
                this.$store.commit(`shiftReport_setEndDate`, v);
                this.$store.dispatch(`shiftReport_updateCache`);
            }
        },
        endTime: {
            get() {
                return this.$store.state.shiftReport.endTime;
            },
            set(v) {
                this.$store.commit(`shiftReport_setEndTime`, v);    
                this.$store.dispatch(`shiftReport_updateCache`);
            }
        },
        getMinDate() {
            const {$moment, startDate} = this;
            return $moment(startDate).format(`YYYY-MM-DD`)
        },
        getMaxDate() {
            const {$moment} = this;
            return $moment(this.getMinDate).add(1, 'days').format('YYYY-MM-DD');
        },
        reasonForDelay: {
            get() {
                return this.$store.state.shiftReport.reasonForDelay;
            },
            set(v) {
                this.$store.commit(`shiftReport_setReasonForDelay`, v);
                this.$store.dispatch(`shiftReport_updateCache`);
            }   
        }
    },
    methods: {
        notValid() {
            const {startDate, startTime, endDate, endTime, disabledData, disabledTime} = this;
            const emptyField = !startDate || !startTime || !endDate || !endTime;
            const result = emptyField || disabledData() || disabledTime();
            return result;
        },
        disabledData() {
            const {$moment, startDate, endDate} = this;
            const a = $moment(endDate);
            const b = $moment(startDate);
            return a.isBefore(b, `millisecond`);
        },
        disabledTime() {
            const {$moment, startDate, endDate} = this;
            const a = $moment(endDate);
            const b = $moment(startDate);
            if (a.isSame(b, 'date')) {
                const {startTime, endTime} = this;
                const a_time = $moment(startTime, 'HH:mm');
                const b_time = $moment(endTime, 'HH:mm');
                return b_time.isBefore(a_time) || b_time.isSame(a_time)
            } else {
                return false
            }
        },
        updateEndDate() {
            const {startDate} = this;
            this.$store.commit(`shiftReport_setEndDate`, startDate);
            this.$store.dispatch(`shiftReport_updateCache`);
        },
        init() {            
            this.$emit(`can-continue`, {
                value: this.canContinue
            });
        },
        startDateChange() {        
            this.updateEndDate();
            this.$store.dispatch(`shiftReport_getAvailableCache`);            
        },
        onUploadClick() {
            this.$store.dispatch(`shiftReport_uploadCache`);
        },
        onContinueClick() {
            this.$store.commit(`shiftReport_setAvailableCache`, []);
            this.$store.dispatch(`shiftReport_clearForm`);
            this.$store.dispatch(`shiftReport_createCache`).then(result => this.$store.commit(`shiftReport_setCache`, result.row));
        },
        isMoreThanThreeDays() {
            const {startDate, startTime} = this;
            if (this.textQualityEnabled) return explanations.delayRequired(startDate, startTime);
            const start = this.$moment(`${startDate} ${startTime}`);
            const now = this.$moment();
            const diff = now.diff(start, 'days');
            const isMore = diff > 2;
            return isMore;
        }
    },
    watch: {canContinue: {immediate: true, handler(value) { this.$emit('can-continue', {value}); }}},
    mounted() {
        this.init();
    }
}
</script>

<style scoped>
.step-two { width: 100%; min-width: 0; }
.step-two__form { width: 100%; max-width: 640px; min-width: 0; margin: 0 auto; }
.step-two__dates { display: grid; grid-template-columns: minmax(0, 3fr) minmax(0, 2fr); gap: 16px; padding: 16px; border: 1px solid #dfe8ee; border-radius: 12px; }
.step-two__dates > * { min-width: 0; }
.step-two__dates input { min-width: 0; max-width: 100%; background: #fff; }
.step-two__dates ::v-deep label { font-size: .9rem; }
.step-two__detail { resize: vertical; overflow-y: auto; }
@media (max-width: 575px) { .step-two__dates { padding: 12px; gap: 12px 8px; } .step-two__dates input { padding-left: 6px; padding-right: 6px; font-size: .875rem; } }
</style>
